
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsOtherPaymentGrid extends Serenity.EntityGrid<PsOtherPaymentRow, any> {
        protected getColumnsKey() { return PsOtherPaymentColumns.columnsKey; }
        protected getDialogType() { return PsOtherPaymentDialog; }
        protected getIdProperty() { return PsOtherPaymentRow.idProperty; }
        protected getInsertPermission() { return PsOtherPaymentRow.insertPermission; }
        protected getLocalTextPrefix() { return PsOtherPaymentRow.localTextPrefix; }
        protected getService() { return PsOtherPaymentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}